// MainPage/MainPage.js
import React from 'react';
import './mainpage.css'; // Update the filename here
import logo from '../../assets/codehidelogo1.png';

function MainPage() {
  return (
    <div className="main-page">
       <h1 className="heading">Barber See Coming Soon</h1>
      <div className="content">
        <p>We are working hard to bring you an amazing experience!</p>
        <p>Stay tuned for updates.</p>
        <div className="info">
          <h2>About Us</h2>
          <p>At BarberSee, we are passionate about delivering top-notch grooming services tailored to the needs of our clients. With a focus on precision and style, our team of experienced barbers offers a wide range of services, including:</p>
          <ul>
            <li>Haircuts for Senior Men, providing a sophisticated and refined look.</li>
            <li>Youth Haircuts, keeping up with the latest trends and styles for our younger clients.</li>
            <li>Beard Trims and Shaping, ensuring a well-groomed and polished appearance.</li>
            <li>Hot Towel Shaves, offering a luxurious and relaxing experience for the modern gentleman.</li>
          </ul>
          <p>Our mission is to create a welcoming and inclusive environment where everyone can feel comfortable and confident. Whether you're seeking a classic haircut or a bold new style, BarberSee is here to exceed your expectations.</p>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
